module.exports = __webpack_public_path__ + "static/media/tick.2bceb13f.svg";